(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    $.ui = $.ui || {};
    return $.ui.version = "1.14.1";
});

//# sourceMappingURL=index.8c5e32a8.js.map
